import React from 'react';
import styles from './Card.module.scss';

interface Props {
  children: React.ReactNode;
}

const Card: React.FC<Props> = ({ children = '' }) => (
  <div className={styles.card}>{children}</div>
);

export default Card;
